import { FC, useEffect } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Loader } from "@/components";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useNavigate } from "react-router-dom";
import { useSingleChallengeBasedOnGame } from "@/features/challenge/hooks/useSingleChallengeBasedOnGame";

const FallGuysChallenge: FC = (): JSX.Element => {
  const navigate = useNavigate();
  useDocumentTitle("Feedback");

  const { slug, loading } = useSingleChallengeBasedOnGame(
    brand.tenantId,
    "finished",
    "fallguys"
  );

  useEffect(() => {
    if (!loading && slug) {
      navigate(`/challenges/${slug}`);
    }
  }, [slug]);

  if (loading) {
    return <Loader />;
  }

  return null;
};

export default FallGuysChallenge;
